// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__tkhMe","label":"SetPasswdForm_label__1zlYI"};